import TariffCard from './TariffCard';

export default TariffCard;
